<div class="page-title-area">
    <div class="container">
      <div class="page-title-content">
        <ul>
          <li><a routerLink="/">Inicio</a></li>
          <li>Configuracion del Calendario</li>
        </ul>
        <h2>Configuracion del Calendario</h2>
      </div>
    </div>
  </div>

<div class="features-area pb-70 animate__animated animate__fadeIn">
    <div class="container">
        <div class="row m-5">
            <!-- Agregar eventos -->
            <div class="col-lg-6 col-sm-6 col-md-6">
                <div class="single-features-box">
                    <div class="icon">
                        <i class="fas fa-calendar-plus"></i>
                    </div>
                    <h3>Agregar Eventos</h3>
                    <p>Crear nuevos eventos en el calendario</p>
                    <a routerLink="/eventos-calendario" class="btn btn-success">Nuevo Evento</a>
                </div>
            </div>

            <!-- Ver calendario -->
            <div class="col-lg-6 col-sm-6 col-md-6">
                <div class="single-features-box">
                    <div class="icon">
                        <i class="fas fa-calendar-alt"></i>
                    </div>
                    <h3>Ver Calendario</h3>
                    <p>Explora todos los eventos programados</p>
                    <a routerLink="/calendario" class="btn btn-primary">Acceder al Calendario</a>
                </div>
            </div>
        </div>
    </div>
</div>